const transformData = (data) => {
    const response = {};
    data.forEach((d, index) => {
        response[d.name] = index === 0;
    });
    return response;
};

export { transformData };
